import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { Asset, SubAsset } from '../../../../models/asset.model';

@Component({
  selector: 'mtm-asset-dropdown-menu',
  templateUrl: './asset-dropdown-menu.component.html',
  styleUrl: './asset-dropdown-menu.component.scss',
  standalone: false,
})
export class AssetDropdownMenuComponent implements AfterViewInit, OnDestroy {
  @ViewChildren('dropdownRef') dropdowns!: QueryList<NgbDropdown>;

  @Input() content!: Asset;
  @Input() funnel!: string;
  @Input() affectedAssets!: Record<string, { subAsset: SubAsset[]; status?: string }>;
  @Input() bundle!: Asset[];
  @Input() isCreator!: boolean;

  // Output events
  @Output() openEditAssetModal: EventEmitter<{ funnel: string; content: Asset; isVariant?: boolean }> =
    new EventEmitter<{
      funnel: string;
      content: Asset;
      isVariant?: boolean;
    }>();
  @Output() duplicateAsset: EventEmitter<any> = new EventEmitter<any>();
  @Output() hideAsset: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteAsset: EventEmitter<any> = new EventEmitter<any>();
  @Output() moveToModalOpen: EventEmitter<any> = new EventEmitter<any>();

  closeDropdownsOnScroll: () => void = () => {
    for (const dropdown of this.dropdowns) {
      if (dropdown.isOpen()) {
        dropdown.close();
      }
    }
  };

  public ngAfterViewInit(): void {
    window.addEventListener('scroll', this.closeDropdownsOnScroll, true);
  }

  public ngOnDestroy(): void {
    window.removeEventListener('scroll', this.closeDropdownsOnScroll, true);
  }

  public onOpenEditAssetModal(isVariant: boolean = false): void {
    this.openEditAssetModal.emit({ funnel: this.funnel, content: this.content, isVariant });
  }

  public onDuplicateAsset(): void {
    this.duplicateAsset.emit(this.content);
  }

  public onHideAsset(): void {
    this.hideAsset.emit(this.content);
  }

  public onDeleteAsset(): void {
    this.deleteAsset.emit(this.content);
  }

  public onMoveToModalOpen_(): void {
    this.moveToModalOpen.emit(this.content);
  }

  public shouldShowDelete(): boolean {
    return (
      !this.content.hidden && this.content.initial === false && this.isCreator && !this.affectedAssets[this.content.id]
    );
  }

  public shouldShowMoveTo(): boolean {
    return !this.content.hidden && this.bundle?.length > 0;
  }
}
